"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatAmountCents = exports.validateRecipientAddress = exports.formatPaymentRail = exports.buildPaymentRailImageUrl = exports.MARKETPLACE_EVENT_CACHE_KEY = exports.dollarsStringToCents = exports.centsToDollarsString = exports.buildPaymentMethods = exports.buildPaymentMethod = exports.ALL_PAYMENT_METHOD_TYPES = exports.PaymentMethodType = exports.MarketplaceActionType = exports.TransactionType = exports.TransactionStatus = exports.stripePaymentIntentStatusToOrderStatus = exports.CLOSED_ORDER_STATUSES = exports.isOrderPurchased = exports.isOrderClosed = exports.OrderStatus = exports.KYCStatus = exports.PaymentRail = void 0;
var PaymentRail;
(function (PaymentRail) {
    PaymentRail[PaymentRail["Stripe"] = 0] = "Stripe";
    PaymentRail[PaymentRail["Paypal"] = 1] = "Paypal";
    PaymentRail[PaymentRail["Coinbase"] = 2] = "Coinbase";
    PaymentRail[PaymentRail["Bitpay"] = 3] = "Bitpay";
    PaymentRail[PaymentRail["CashApp"] = 4] = "CashApp";
    PaymentRail[PaymentRail["Moneyline"] = 5] = "Moneyline";
})(PaymentRail || (exports.PaymentRail = PaymentRail = {}));
var KYCStatus;
(function (KYCStatus) {
    KYCStatus[KYCStatus["NotNecessary"] = 0] = "NotNecessary";
    KYCStatus[KYCStatus["Verified"] = 1] = "Verified";
    KYCStatus[KYCStatus["RequiresAction"] = 2] = "RequiresAction";
    KYCStatus[KYCStatus["Pending"] = 3] = "Pending";
    KYCStatus[KYCStatus["Failed"] = 4] = "Failed";
})(KYCStatus || (exports.KYCStatus = KYCStatus = {}));
var OrderStatus;
(function (OrderStatus) {
    OrderStatus[OrderStatus["Pending"] = 0] = "Pending";
    OrderStatus[OrderStatus["Processing"] = 1] = "Processing";
    OrderStatus[OrderStatus["Canceled"] = 2] = "Canceled";
    OrderStatus[OrderStatus["RequiresAction"] = 3] = "RequiresAction";
    OrderStatus[OrderStatus["RequiresCapture"] = 4] = "RequiresCapture";
    OrderStatus[OrderStatus["RequiresConfirmation"] = 5] = "RequiresConfirmation";
    OrderStatus[OrderStatus["RequiresPaymentMethod"] = 6] = "RequiresPaymentMethod";
    OrderStatus[OrderStatus["Succeeded"] = 7] = "Succeeded";
    OrderStatus[OrderStatus["Refunded"] = 8] = "Refunded";
    OrderStatus[OrderStatus["Failed"] = 9] = "Failed";
    OrderStatus[OrderStatus["Completed"] = 10] = "Completed";
})(OrderStatus || (exports.OrderStatus = OrderStatus = {}));
const isOrderClosed = (status) => {
    switch (status) {
        case OrderStatus.Succeeded:
        case OrderStatus.Completed:
        case OrderStatus.Refunded:
        case OrderStatus.Canceled:
        case OrderStatus.Failed:
            return true;
        default:
            return false;
    }
};
exports.isOrderClosed = isOrderClosed;
const isOrderPurchased = (status) => {
    switch (status) {
        case OrderStatus.Succeeded:
        case OrderStatus.Completed:
        case OrderStatus.Refunded:
            return true;
        default:
            return false;
    }
};
exports.isOrderPurchased = isOrderPurchased;
exports.CLOSED_ORDER_STATUSES = [
    OrderStatus.Canceled,
    OrderStatus.Completed,
    OrderStatus.Succeeded,
    OrderStatus.Refunded,
];
const stripePaymentIntentStatusToOrderStatus = (status) => {
    switch (status) {
        case "processing":
            return OrderStatus.Processing;
        case "canceled":
            return OrderStatus.Canceled;
        case "requires_action":
            return OrderStatus.RequiresAction;
        case "requires_capture":
            return OrderStatus.RequiresCapture;
        case "requires_confirmation":
            return OrderStatus.RequiresConfirmation;
        case "requires_payment_method":
            return OrderStatus.RequiresPaymentMethod;
        case "succeeded":
            return OrderStatus.Succeeded;
        default:
            return OrderStatus.Pending;
    }
};
exports.stripePaymentIntentStatusToOrderStatus = stripePaymentIntentStatusToOrderStatus;
var TransactionStatus;
(function (TransactionStatus) {
    TransactionStatus[TransactionStatus["Pending"] = 0] = "Pending";
    TransactionStatus[TransactionStatus["Canceled"] = 1] = "Canceled";
    TransactionStatus[TransactionStatus["Failed"] = 2] = "Failed";
    TransactionStatus[TransactionStatus["Completed"] = 3] = "Completed";
})(TransactionStatus || (exports.TransactionStatus = TransactionStatus = {}));
var TransactionType;
(function (TransactionType) {
    TransactionType[TransactionType["Sale"] = 0] = "Sale";
    TransactionType[TransactionType["Refund"] = 1] = "Refund";
    TransactionType[TransactionType["Payout"] = 2] = "Payout";
    TransactionType[TransactionType["Adjustment"] = 3] = "Adjustment";
})(TransactionType || (exports.TransactionType = TransactionType = {}));
var MarketplaceActionType;
(function (MarketplaceActionType) {
    MarketplaceActionType[MarketplaceActionType["DepositBalance"] = 0] = "DepositBalance";
    MarketplaceActionType[MarketplaceActionType["WithdrawBalance"] = 1] = "WithdrawBalance";
    MarketplaceActionType[MarketplaceActionType["CreatePaymentIntent"] = 2] = "CreatePaymentIntent";
    MarketplaceActionType[MarketplaceActionType["AttachPaymentMethod"] = 3] = "AttachPaymentMethod";
    MarketplaceActionType[MarketplaceActionType["Checkout"] = 4] = "Checkout";
    MarketplaceActionType[MarketplaceActionType["ConfirmPayment"] = 5] = "ConfirmPayment";
})(MarketplaceActionType || (exports.MarketplaceActionType = MarketplaceActionType = {}));
var PaymentMethodType;
(function (PaymentMethodType) {
    PaymentMethodType["Card"] = "card";
})(PaymentMethodType || (exports.PaymentMethodType = PaymentMethodType = {}));
exports.ALL_PAYMENT_METHOD_TYPES = [
    PaymentMethodType.Card,
];
const buildPaymentMethod = (input) => {
    var _a, _b, _c, _d;
    return {
        id: input.id,
        brand: ((_a = input.card) === null || _a === void 0 ? void 0 : _a.brand) || "Unknown",
        last4: ((_b = input.card) === null || _b === void 0 ? void 0 : _b.last4) || "****",
        exp_month: ((_c = input.card) === null || _c === void 0 ? void 0 : _c.exp_month) || 0,
        exp_year: ((_d = input.card) === null || _d === void 0 ? void 0 : _d.exp_year) || 0,
        type: input.type,
    };
};
exports.buildPaymentMethod = buildPaymentMethod;
const buildPaymentMethods = (input) => {
    return input.map((pm) => (0, exports.buildPaymentMethod)(pm));
};
exports.buildPaymentMethods = buildPaymentMethods;
const centsToDollarsString = (cents) => {
    const str = Math.abs(cents).toString();
    const sign = cents < 0 ? "-" : "";
    return (sign +
        (str.length > 2
            ? str.slice(0, -2) + "." + str.slice(-2)
            : "0." + str.padStart(2, "0")));
};
exports.centsToDollarsString = centsToDollarsString;
const dollarsStringToCents = (input) => {
    const [dollars = "0", cents = "00"] = input.split(".");
    return parseInt(dollars) * 100 + parseInt(cents.padEnd(2, "0").slice(0, 2));
};
exports.dollarsStringToCents = dollarsStringToCents;
exports.MARKETPLACE_EVENT_CACHE_KEY = "marketplace_event";
const buildPaymentRailImageUrl = (paymentRail) => {
    switch (paymentRail) {
        case PaymentRail.Bitpay: {
            return "/logos/bitpay.svg";
        }
        case PaymentRail.Paypal: {
            return "/logos/paypal.svg";
        }
        case PaymentRail.CashApp: {
            return "/logos/cashapp.svg";
        }
        default: {
            throw new Error("Unsupported payment rail.");
        }
    }
};
exports.buildPaymentRailImageUrl = buildPaymentRailImageUrl;
const formatPaymentRail = (paymentRail) => {
    switch (paymentRail) {
        case PaymentRail.Bitpay: {
            return "bitpay";
        }
        case PaymentRail.Paypal: {
            return "paypal";
        }
        case PaymentRail.CashApp: {
            return "cashapp";
        }
        case PaymentRail.Coinbase: {
            return "coinbase";
        }
        default: {
            throw new Error("Unsupported payment rail.");
        }
    }
};
exports.formatPaymentRail = formatPaymentRail;
const validateRecipientAddress = (rail, address) => {
    if (!address.trim())
        return false;
    switch (rail) {
        case PaymentRail.Paypal:
        case PaymentRail.Bitpay:
            return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(address);
        case PaymentRail.CashApp:
            return /^\$[a-zA-Z0-9_]{1,20}$/.test(address);
        case PaymentRail.Coinbase:
            return address.length >= 26 && address.length <= 100 && !/\s/.test(address);
        default:
            return false;
    }
};
exports.validateRecipientAddress = validateRecipientAddress;
const formatAmountCents = (cents) => {
    if (!cents || isNaN(cents)) {
        return { whole: "0", decimal: "00" };
    }
    const str = Math.abs(cents).toString().padStart(3, "0");
    const sign = cents < 0 ? "-" : "";
    const dollars = str.slice(0, -2);
    const centsPart = str.slice(-2);
    return {
        whole: sign + dollars,
        decimal: centsPart,
    };
};
exports.formatAmountCents = formatAmountCents;
